export const LOADING = 'eatery.LOADING';
export const LOADED = 'eatery.LOADED';